import * as React from 'react';

function Grumpy(props) {
	return (
		<svg
			width="60"
			height="60"
			viewBox="0 0 60 60"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z"
				fill="#6FCC87"
			/>
			<path
				opacity="0.5"
				d="M36.4286 55.5707C19.8601 55.5707 6.42875 42.1393 6.42875 25.5709C6.42875 16.7189 10.2633 8.76372 16.3612 3.27246C6.64894 8.23837 0 18.3425 0 29.9996C0 46.5681 13.4314 59.9994 29.9998 59.9994C37.7165 59.9994 44.7517 57.085 50.0672 52.2982C45.9753 54.3903 41.34 55.5707 36.4286 55.5707Z"
				fill="#186C2D"
			/>
			<path
				d="M44.8053 20.7139C44.8053 22.9647 46.6299 24.7892 48.8806 24.7892C51.1314 24.7892 52.9559 22.9646 52.9559 20.7139H39.1631"
				fill="white"
			/>
			<path
				d="M23.9596 20.7139C23.9596 22.9647 25.7842 24.7892 28.0349 24.7892C30.2856 24.7892 32.1102 22.9646 32.1102 20.7139H18.3174"
				fill="white"
			/>
			<path
				d="M27.1767 46.355C26.85 46.355 26.5238 46.2245 26.2835 45.9664C25.8241 45.4732 25.8514 44.7011 26.3445 44.2416C28.3947 42.3315 31.9658 41.145 35.6642 41.145C39.5313 41.145 43.0062 42.3143 44.9593 44.2727C45.4353 44.75 45.4342 45.5227 44.9571 45.9985C44.4798 46.4746 43.7071 46.4734 43.231 45.9963C41.7483 44.5095 38.8487 43.5859 35.6642 43.5859C32.5586 43.5859 29.6249 44.5215 28.0085 46.0276C27.7732 46.2466 27.4745 46.355 27.1767 46.355Z"
				fill="#186C2D"
			/>
			<path
				d="M52.9555 19.4932H39.1628C38.4887 19.4932 37.9424 20.0396 37.9424 20.7135C37.9424 21.3875 38.4888 21.9339 39.1628 21.9339H43.7264C44.279 24.2676 46.3801 26.0092 48.8802 26.0092C51.8003 26.0092 54.1759 23.6335 54.1759 20.7135C54.176 20.0394 53.6296 19.4932 52.9555 19.4932ZM48.8802 23.5685C47.7425 23.5685 46.758 22.8993 46.2996 21.934H51.4608C51.0025 22.8993 50.018 23.5685 48.8802 23.5685Z"
				fill="#186C2D"
			/>
			<path
				d="M33.3302 20.7135C33.3302 20.0395 32.7838 19.4932 32.1098 19.4932H18.3171C17.643 19.4932 17.0967 20.0396 17.0967 20.7135C17.0967 21.3875 17.6431 21.9339 18.3171 21.9339H22.8807C23.4333 24.2676 25.5344 26.0092 28.0345 26.0092C30.9546 26.0093 33.3302 23.6335 33.3302 20.7135ZM25.4539 21.934H30.6151C30.1567 22.8996 29.1722 23.5685 28.0344 23.5685C26.8968 23.5685 25.9123 22.8993 25.4539 21.934Z"
				fill="#186C2D"
			/>
		</svg>
	);
}

export default Grumpy;
